import { render, staticRenderFns } from "./indexAdvertisingList.vue?vue&type=template&id=054eb46f&"
import script from "./indexAdvertisingList.vue?vue&type=script&lang=js&"
export * from "./indexAdvertisingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports